import Sortable from "sortablejs/modular/sortable.core.esm.js"
import { post } from "shared/lib/api"

export default function actionFieldsSortable(updateUrl) {
  const _url = updateUrl

  function reorderActionFields() {
    let actionFieldIds = []
    document.querySelectorAll(".field-list li").forEach(triggerField => {
      actionFieldIds.push(triggerField.dataset["actionFieldId"])
    })

    post(_url, { item_ids: actionFieldIds })
      .then(() => {
        App.Scripts.partners.displayFlash("Action fields reordered")
      })
      .catch(() => {
        App.Scripts.partners.displayFlash(
          "There has been an error reordering the action fields, try again!",
          "error"
        )
      })
  }

  const inputsEl = document.getElementById("input-list")
  return Sortable.create(inputsEl, {
    animation: 150,
    onUpdate: reorderActionFields,
  })
}
